import React  from 'react';
import { BgisButtonIcon, BgisIcon } from '../../../../icon';
import { toggleClass } from '../../../../../util/dom';

export type BgisLegendProps = {
  description: string;
  title: string;
  children?: React.ReactNode;
};

export const BgisLegend: React.FC<BgisLegendProps> = ({ description, title, children }: BgisLegendProps) => {

  return (
    <section className='bgis-legend'>
      <header className="bgis-legend-header">
        <span className="bgis-legend-header-title">
          <BgisIcon iconName={'bgis-icon-map'}></BgisIcon>
          <span className="bgis-txt">
            <span className="bgis-overline">{description}</span>
            <span className="bgis-headline6">{title}</span>
          </span>
          <BgisIcon iconName={'bgis-icon-layer-group'}></BgisIcon>
        </span>
        <div className="bgis-legend-header-open">
          <span className="bgis-caption">Legende &amp; Infos anzeigen</span>
          <span className="bgis-grow1"></span>
          <BgisButtonIcon iconName='bgis-icon-chevron-down' title="Zeige detaillierte Legendeninfos zur Karte an." onClick={() => toggleClass('.bgis-map-area', 'show-legend')}></BgisButtonIcon>
        </div>
        <div className="bgis-legend-header-tabs">
          <button className="bgis-layers-tab bgis-caption" onClick={() => toggleClass('.bgis-legend', 'info')}>
            Legende
          </button>
          <button className="bgis-infos-tab bgis-caption" onClick={() => toggleClass('.bgis-legend', 'info')}>
            Infos
          </button>
          <span className="bgis-grow"></span>
          <BgisButtonIcon iconName='bgis-icon-chevron-up' title="Detaillierte Legendinfo ausblenden." onClick={() => toggleClass('.bgis-map-area', 'show-legend')}></BgisButtonIcon>
        </div>
      </header>
      {children}
    </section>
  );
};
